var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCriticalAttentionNeeded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Critical",
    clipPath: "url(#clip0_1232_23546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stethoscope_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.33333 2.66667C5.33333 2.29848 5.03485 2 4.66667 2C4.29848 2 4 2.29848 4 2.66667C2.89543 2.66667 2 3.5621 2 4.66667V6C2 7.982 3.44153 9.62733 5.33333 9.94467V10C5.33333 12.2091 7.1242 14 9.33333 14C11.5425 14 13.3333 12.2091 13.3333 10V9.21953C14.1101 8.945 14.6667 8.20413 14.6667 7.33333C14.6667 6.22877 13.7713 5.33333 12.6667 5.33333C11.5621 5.33333 10.6667 6.22877 10.6667 7.33333C10.6667 8.20413 11.2232 8.945 12 9.21953V10C12 11.4727 10.8061 12.6667 9.33333 12.6667C7.8606 12.6667 6.66667 11.4727 6.66667 10V9.94467C8.55847 9.62733 10 7.982 10 6V4.66667C10 3.5621 9.1046 2.66667 8 2.66667C8 2.29848 7.70153 2 7.33333 2C6.96513 2 6.66667 2.29848 6.66667 2.66667V4C6.66667 4.36819 6.96513 4.66667 7.33333 4.66667C7.70153 4.66667 8 4.36819 8 4C8.3682 4 8.66667 4.29848 8.66667 4.66667V6C8.66667 7.47273 7.47273 8.66667 6 8.66667C4.52724 8.66667 3.33333 7.47273 3.33333 6V4.66667C3.33333 4.29848 3.63181 4 4 4C4 4.36819 4.29848 4.66667 4.66667 4.66667C5.03485 4.66667 5.33333 4.36819 5.33333 4V2.66667Z",
    fill: "#FFA7A1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1232_23546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticalAttentionNeeded);
export default __webpack_public_path__ + "static/media/critical-attention-needed.033c04393831784736216cb31cccee87.svg";
export { ForwardRef as ReactComponent };